export default "__VITE_ASSET__D$ijcr5m__"